
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'VacanciesWeOfferBlock',

  data: function () {
    return {
      isPlay: false,
    }
  },

  computed: {
    localValues: function () {
      return this.externalData?.VacanciesWeOfferBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
    isVideo: function () {
      return Boolean(this.extras?.video);
    },
  },
  methods: {
    onPlayVideo: function () {
      if (this.isPlay) {
        return
      }

      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.startVideo();
        }, 500);
        return;
      }

      this.isPlay = true;
      if (this.$refs.refVideo.readyState === 0) { this.$refs.refVideo.load(); }
      const playPromise = this.$refs.refVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(() => {}); }
    },
    onPauseVideo: function () {
      this.$refs.refVideo.pause();
      this.isPlay = false;
    },
  },
});
